import React, { useState, useRef } from 'react';

const FullTextSearch = props => {
    const [inputValue, setInputValue] = useState(props.value || '');
    const inputRef = useRef(null);
    let timeout = null;

    const getSearchResults = e => {
        if (timeout) clearTimeout(timeout);
        if (e.key === 'Enter') {
            props.loadSearchData(e.target.value);
        }
    };

    const clearInput = () => {
        setInputValue('');
        props.loadSearchData('');
        inputRef.current?.focus();
    };

    return (
        <div className="table-search">
            <input
                ref={inputRef}
                value={inputValue}
                type="text"
                id="mfx-mainsearch-input"
                className="mfx-search-input"
                placeholder={window.Dictionary?.getTranslation(7745)}
                onKeyUp={getSearchResults}
                onChange={e => setInputValue(e.target.value)}
            />
            {inputValue && (
                <span className="mfx-clear-btn" onClick={clearInput}>
                    ×
                </span>
            )}
        </div>
    );
};

export default FullTextSearch;
